export const GET_VAT_REQUEST="GET_VAT_REQUEST"
export const GET_VAT_SUCCESS="GET_VAT_SUCCESS"
export const GET_VAT_FAILURE="GET_VAT_FAILURE"